import { jsx as _jsx } from "react/jsx-runtime";
var Diploma = function Diploma(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 17 17",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M16.3,2.2c-1.8-1.7-4.2-2.4-5.7-0.8L7.5,4.5l-3-3C4.3,1.3,4,1.3,3.8,1.4C3.6,1.5,3.5,1.7,3.5,1.9v2.2H1.3 c-0.2,0-0.4,0.1-0.5,0.3C0.7,4.6,0.8,4.8,0.9,5l3,3L1,10.8c-1,1-0.6,2.8,0.9,4.3c1.4,1.4,3.3,1.8,4.3,0.8l0,0 c13-12.9,8.6-8.6,9.6-9.5l0,0l0,0c0.8-0.8,0.6-1.9-0.1-2.8L16.3,3C16.5,2.8,16.6,2.5,16.3,2.2z M15.1,2.7l-3.5,3.4 C10.8,5.2,9.9,4.6,9,4.4l2.3-2.3C12.1,1.5,13.5,1.2,15.1,2.7z M6.3,11.4c-1.1-1-2.1-1.3-2.8-1.4l1.9-1.9l0,0c0.6-0.6,2.1,0,3.1,1.2 L6.3,11.4z M11.6,8.2c0.1,0.5,0.1,0.8-0.2,1.1l-1.2,1.1C9.9,8.8,8.3,7.2,6.7,6.8c0.2-0.2,1-1,1.2-1.2C8.6,4.9,11.1,6.3,11.6,8.2z M4.7,7.2l-2.1-2H4c0.3,0,0.6-0.2,0.6-0.6V3.2l2.1,2.1C5.5,6.4,5.9,6.1,4.7,7.2z M2.7,14.3c-1.1-1-1.3-2.3-0.9-2.7 C2.3,11.1,3,11,3.6,11.1l-1.1,1.2c-0.2,0.2-0.2,0.5,0,0.8c0.2,0.2,0.5,0.2,0.8,0.1C3.5,13,4.4,12.9,5,13.5c0.5,0.4,0.8,1.2,0.4,1.7 C5,15.6,3.7,15.4,2.7,14.3z M4.4,12l0.4-0.4c0.7,0.4,1.3,1,1.2,0.9c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2l2.3-2.3 c0.2,0.6,0.2,1.1,0,1.4L6.7,14C6.3,13.1,5.5,12.2,4.4,12z M15,5.7L12.7,8c-0.1-0.3-0.2-0.6-0.4-1l2.6-2.6C15.2,4.8,15.3,5.3,15,5.7z "
    })
  });
};
export default Diploma;